<div class="flxClmn bs-enabled">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container flxRow">
			<span class="page-title">Training Materials</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">
				Security awareness content to use as landing pages in your campaigns
			</span>
		</div>
	</div>

	<!--loader-->
	<div class="f-1-0 flex-column centralize " *ngIf="_.isUndefined(isThisFeatureSupported)">
		<loader height="100" width="100" style="opacity: 0.8;"></loader>
	</div>

	<div class="page-inner-content-holder flxClmn vSpace2" *ngIf="isThisFeatureSupported"
		 [ngClass]="{'no-scroll' : pageView === pageViews.table}">

		<div class="flex-column f-1-0 gap-3" [ngClass]="{'overflow-auto' : pageView === pageViews.table}">
			<div class="flex-row justify-content-between align-items-center">
				<div class="flex-row gap-2">
					<btn-c [isDisabled]="getMaterialsInProcess"
						   (action)="openNewMaterialPopup();"
						   style="background: white; width: 140px;"
						   variant="outlined"
						   endIcon="far fa-lg fa-file-medical ms-2">
						Add Materials
					</btn-c>
					<btn-c [isDisabled]="getMaterialsInProcess"
						   (action)="openNewMaterialAiWizard();"
						   class="colorful-border-rainbow" style="background: white; width: 140px;"
						   variant="outlined"
						   endIcon="fa fa-lg fa-magic ms-2">
						Create With AI
					</btn-c>
					<div class="vertical-separator h-auto mx-2 opacity-25"></div>
					<div class="period-buttons-group bs-enabled flex-row gap-2">
						<button class="period-button flex-row gap-2 bs-btn bs-btn-light text-capitalize"
								*ngFor="let view of pageViews | keyvalue: gs.returnZero"
								[ngClass]="{'chosen' : view.value === pageView}"
								[tooltip]="view.value === pageViews.gallery ? 'Gallery view' : 'Table view'"
								(click)="currentMaterial = null; getMaterialFileDataInProcess = false; pageView = view.value;">
							<i [ngClass]="{'fa-th-large' : view.value === pageViews.gallery, 'fa-list-ul' : view.value === pageViews.table, 'far' : true}" ></i>
						</button>
					</div>
				</div>
				<div class="flex-row gap-2 align-items-end" *ngIf="pageView === pageViews.gallery">
					<span *ngIf="_.reject(materials, 'hide').length" style="padding: 5px;">
						{{_.reject(materials, 'hide').length}} material{{_.reject(materials, 'hide').length === 1 ? '' : 's'}}
					</span>
					<search-box [(model)]="searchMaterialTxt"
								(modelChange)="searchMaterial(searchMaterialTxt, activeFilters);"
								placeholder="Search material"
								style="width: 33%; min-width: 250px;">
					</search-box>
					<div class="position-relative">
						<a class="border rounded-2" style="align-items: center; font-size: 16px; padding: 4px 7px; position: relative;"
						   [tooltip]="activeFilters ? 'Filter results - Active' : 'Filter results'"
						   (click)="filterData.show = !filterData.show"
						   [ngStyle]="{'color': activeFilters ? 'var(&#45;&#45;bs-primary)' : ''}">
							<i class="far fa-filter" style="width: 23px; height: 23px; align-items: center;"></i>
							<i class="animated fadeIn fa fa-circle" style="position: absolute; top: 4px; right: 7px; font-size: 8px; filter: drop-shadow(-2px 1px 1px white); color: #00d100;"
							   *ngIf="activeFilters"></i>
						</a>
						<filter-table-c
							style="position: absolute; bottom: -3px; transform: translateY(100%); right: 0; z-index: 50;"
							*ngIf="filterData"
							[filterData]="filterData"
							(applyCb)="activeFilters = $event.activeFilters; searchMaterial(searchMaterialTxt, activeFilters);"
							(clearCb)="activeFilters = $event.activeFilters; searchMaterial(searchMaterialTxt, activeFilters);">
						</filter-table-c>
					</div>
				</div>
			</div>
			<!--VIEW: GRID-->
			<ng-container *ngFor="let materialList of materialsForGallery | keyvalue: gs.returnZero">
				<div class="flex-column p-3 border bg-light" style="min-height: 350px; --bs-border-style: dashed;" *ngIf="pageView === pageViews.gallery && materialList.value.length">
					<div class="flex-column gap-2 gap-3 animated fadeIn">
						<h5 class="fw-bolder">{{_.startCase(materialList.key)}} Materials</h5>

						<div class="w-100 animated fadeIn" style="display: grid; grid-gap: 1rem; grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));">
							<div class="animated fadeIn" style="height: 270px; max-width: 325px;" *ngFor="let material of materialList.value  | filter: {hide : '!true'} | orderBy: '-created'; let index = index;">
								<div class="border rounded-3 bg-white overflow-hidden flex-column h-100 position-relative cursor-pointer hvr-opacity shadow-sm"
									 (click)="setCurrentMaterial(material)">
									<div class="d-flex centralize border-bottom h-75" style="background: url('images/material-placeholder-bg.png'); background-size: 157%; background-position: center center; filter: contrast(1.1);">
										<img class="h-100" style="width:100%; object-fit:cover; object-position:center;"
											 *ngIf="material.thumbnail" [src]="material.thumbnail">
										<span style="position: absolute; bottom: 0; right: 0; padding: 2px 5px; background: white; opacity: 0.75;"
											  *ngIf="material.length_seconds">
											{{material.length_seconds}}
										</span>
										<ng-container *ngIf="!material.thumbnail">
											<i [ngClass]="{'fa' : true, 'text-muted' : true, 'fa-file-powerpoint' : material.type === 'application/vnd.ms-powerpoint' || material.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
															'fa-file-pdf' : material.type === 'application/pdf',
															'fa-link' : material.type === 'link',
															'fa-question-circle' : material.type === 'quiz',
															'fa-film' : material.type.includes('AI') || material.type === 'Hook Security' || material.type === 'video/mp4'}"
											   style="font-size: 6rem; opacity: 0.5;"></i>
										</ng-container>
										<!--powered by banner-->
										<div class="bg-light p-1" style="font-size: 12px; position: absolute; top: 8px; left: 0; opacity: 0.8;"
											 *ngIf="material.type === 'Hook Security' || material.type === 'Trustifi AI'">
											<span class="fst-italic" *ngIf="material.type === 'Hook Security'">Hook Security</span>
											<span class="fst-italic" *ngIf="material.type === 'Trustifi AI'">Trustifi AI</span>
										</div>
										<!--actions menu-->
										<div class="toggled-menu-container" style="position: absolute; top: 5px; right: 5px;"
											 *ngIf="!material.system"
											 (click)="$event.stopPropagation();">
											<i class="fas fa-ellipsis-h bg-light border border-2 rounded-2" style="padding: 5px;"
											   [id]="'menu' + index + 'Trigger'" tooltip="Menu"
											   (click)="material.showMenu = !material.showMenu"></i>
											<div class="drop-menu" style="right: 0; left: auto; min-height: 0;" [ngClass]="{'active' : material.showMenu}">
												<ul (clickOutside)="material.showMenu = false;"
													[exclude]="'#menu' + index + 'Trigger'">
													<li class="flex-row align-items-center"
														*ngIf="!material.link_url && material.type !== 'quiz' && material.type !== 'AI'"
														(click)="selectMaterialAction(material, dic.CONSTANTS.actions.download);">
														<span>Download</span>
													</li>
													<ng-container *ngIf="material.type === 'quiz'">
														<li class="flex-row align-items-center"
															(click)="material.showMenu = false; selectMaterialAction(material, 'edit');">
															<span>Edit</span>
														</li>
														<li class="flex-row align-items-center"
															(click)="material.showMenu = false; selectMaterialAction(material, 'duplicate');">
															<span>Duplicate</span>
														</li>
													</ng-container>
													<li class="flex-row align-items-center text-danger"
														(click)="selectMaterialAction(material, dic.CONSTANTS.actions.delete);">
														<span>Delete</span>
													</li>
												</ul>
											</div>
										</div>
									</div>

									<div class="flex-column justify-content-center bg-white gap-1 p-2 h-25">
										<div class="flex-row justify-content-between gap-2">
											<span class="fw-500 f-1-0">{{material.name}}</span>
											<i class="far fa-info-circle text-info"
											   *ngIf="material.description" [tooltip]="material.description"></i>
										</div>

										<div class="flex-row gap-2 f-1-0 justify-content-between align-items-end" style="font-size: 12px;">
											<div class="rounded-3 border bg-secondary text-white" style="padding: 2px 5px; letter-spacing: 0.5px; --bs-border-style: solid;"
												 *ngIf="material.completedSubtitles?.length"
												 [tooltip]="'Available subtitles for this video: ' + material.completedSubtitles.join(', ')">
												<span>CC</span>
											</div>
											<span *ngIf="!material.completedSubtitles?.length"></span>
											<div class="flex-row gap-2 align-items-center flex-wrap justify-content-end">
												<div class="flex-row align-items-center gap-2 rounded-3" style="border: solid 1px; padding: 2px 5px;"
													 *ngFor="let tag of material.metaTags"
													 [ngStyle]="{'color' : tag.color, 'border-color' : tag.color}">
													<i [ngClass]="tag.iconClass"></i>
													<span>{{tag.name}}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<span class="text-muted text-center d-block m-auto" style="font-size: 14px;"
						  *ngIf="pageView === pageViews.gallery && _.every(materialList.value, 'hide')">
						No materials found in this search or filter
					</span>
				</div>
			</ng-container>
			<div class="flxRow animated fadeIn" style="flex: 1 0; overflow: auto;" *ngIf="pageView === pageViews.table">
				<!--list of materials (left side)-->
				<div class="flxClmn" style="flex: 1.8 0; padding: 5px; min-width: 450px; min-height: 350px; background: linear-gradient(#163f5d1a, transparent, #a0a0a02e) , linear-gradient(74deg, #d3f1ff6b , transparent 51%, transparent);">
					<div class="flxClmn" style="flex: 1 0; overflow: auto;">
						<div class="flex-row justify-content-end gap-2" style="background: #677184; padding: calc(3px + 0.4vw); align-items: center; z-index: 1; min-height: 42px;">
							<span *ngIf="_.reject(materials, 'hide').length" style="color: white; padding: 5px;">
                                {{_.reject(materials, 'hide').length}} record{{_.reject(materials, 'hide').length === 1 ? '' : 's'}}
                            </span>
							<!--Search-->
							<search-box [(model)]="searchMaterialTxt"
										(modelChange)="materialsListEl.searchItem();"
										placeholder="Search material"
										style="width: 30%; min-width: 200px;">
							</search-box>
						</div>

						<trustifi-table-c
							#materialsListEl
							class="trustifi-table" style="flex: 1 0; z-index: 5; background: white;"
							[list]="materials"
							[headers]="[
							{text: '', width: '25px'},
							{text: 'Name', sortKey: 'name'},
							{text: 'Description', width: '95px', centered: true},
						]"
							[cellsPrototype]="[
							{html: 'iconCell'},
							{html: 'nameCell'},
							{html: 'descriptionCell'},
						]"
							[bulkActions] = "{
							enable: true,
							selectBulkActionCb:	selectMultipleMaterialAction,
							initBulkActionsFunction: showMultipleMaterialsActions,
							showInRed: {enable: true, terms: ['Delete']}
						}"
							[cellActions]="{
							enable: true,
							selectItemActionCb:	selectMaterialAction,
							initActionsFunction: showMaterialActions,
							showInRed: {enable: true, terms: ['Delete']}
						}"
							(onAnyItemSelected)="!$event.isItemSelectCheckboxClicked && setCurrentMaterial($event.item)"
							(searchFunction)="searchMaterial(searchMaterialTxt, {})"
							[options]="{
							loadingTableFlag: getMaterialsInProcess,
							soloSelected: true,
							hideContentAboveTable: true,
							itemsNameSingular: 'material',
							defaultSortKey: '-created'
						}"
						>
							<ng-template #customCells let-item let-cellId="cellId">
							<span *ngIf="cellId === 'iconCell'">
								<i class="fa fa-magic" *ngIf="item.type === 'Trustifi AI' || item.type === 'AI' || item.type === 'Hook Security'"></i>
								<i class="far fa-link" *ngIf="item.type === 'link'"></i>
								<i class="far fa-file-pdf text-danger" *ngIf="item.type === 'application/pdf'"></i>
								<i class="far fa-clipboard-list" *ngIf="item.type === 'quiz'"></i>
								<i class="far fa-file-powerpoint text-warning" *ngIf="!item.link_url && item.type !== 'quiz' && item.type !== 'application/pdf'"></i>
							</span>

								<div *ngIf="cellId === 'nameCell'"
									 class="flex-row gap-1 align-items-end">
									<span>{{item.name}}</span>
									<span class="text-muted" style="font-size: 11px;" *ngIf="item.system">(System)</span>
								</div>

								<div class="d-flex centralize" *ngIf="cellId === 'descriptionCell'">
									<i class="far fa-info-circle text-info opacity-75" style="font-size: 16px;"
									   *ngIf="item.description" [tooltip]="item.description">
									</i>
								</div>
							</ng-template>
						</trustifi-table-c>
					</div>
				</div>

				<!--Email display area (right side)-->
				<div class="vertical-separator mx-3 h-auto" style="opacity: 0.05;"></div>
				<div class="flxClmn" style="flex: 2 0; position: relative; overflow: auto; align-items: center;"
					 [ngStyle]="{'background': currentMaterial ? 'transparent' : '#f7f7f7'} ">
					<!--loading overlay-->
					<div class="flxClmn-center animated fadeIn" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; background: rgba(255,255,255,0.6); align-items: center;"
						 *ngIf="getMaterialFileDataInProcess">
						<div class="loading-spinner" style="position: relative; top: 0; left: 0; opacity: 1;"></div>
					</div>
					<!----->
					<div class="flex-column gap-2 f-1-0 w-100 animated fadeIn overflow-auto" *ngIf="currentMaterial">
						<ng-container *ngTemplateOutlet="materialDetailsTemplate"></ng-container>
					</div>


					<div *ngIf="!currentMaterial && !getMaterialFileDataInProcess" class="flxClmn-center"
						 style="align-items: center; flex: 1 0;">
						<i class="far hvr-opacity fa-file" style="font-size: 4vw;  opacity: 0.1;"></i>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!--feature not supported-->
	<threat-simulation-not-supported style="display: contents;" *ngIf="isThisFeatureSupported === false"></threat-simulation-not-supported>
	<!---->
</div>

<popup-c class="no-content-padding bs-enabled" *ngIf="pageView === pageViews.gallery && (getMaterialFileDataInProcess || currentMaterial)"
		 head="Training Material Details" size="large"
		 (closeCb)="currentMaterial = null; getMaterialFileDataInProcess = false;"
		 [buttons]="{cancel: 'OK'}">
	<div class="flex-column f-1-0" style="overflow: auto;">
		<div class="f-1-0 d-flex centralize" *ngIf="!currentMaterial">
			<loader *ngIf="getMaterialFileDataInProcess" height="100" width="100" style="opacity: 0.8;"></loader>
			<i class="far fa-times-circle text-danger opacity-50 animated fadeIn" style="font-size: 2rem;"
			   *ngIf="!getMaterialFileDataInProcess"></i>
		</div>

		<div class="flex-column f-1-0 gap-2 p-3 animated fadeIn overflow-auto" style="min-height: 650px;" *ngIf="currentMaterial">
			<ng-container *ngTemplateOutlet="materialDetailsTemplate"></ng-container>
		</div>
	</div>
</popup-c>

<ng-template #materialDetailsTemplate>
	<div class="flex-column border border-secondary-subtle p-4 gap-3" style="z-index: 50;">
		<ng-container>
			<ng-container *ngTemplateOutlet="currentMaterialField; context: {$implicit: 'name'}"></ng-container>
		</ng-container>

		<ng-container *ngIf="currentMaterial.type === 'link'">
			<ng-container *ngTemplateOutlet="currentMaterialField; context: {$implicit: 'link_url'}"></ng-container>
		</ng-container>

		<ng-container *ngTemplateOutlet="currentMaterialField; context: {$implicit: 'description'}"></ng-container>

		<ng-container *ngIf="currentMaterial.tags?.length">
			<ng-container *ngTemplateOutlet="currentMaterialField; context: {$implicit: 'tags'}"></ng-container>
		</ng-container>

		<div class="flex-column gap-2" *ngIf="currentMaterial.type === 'AI' || currentMaterial.type === 'Trustifi AI' || currentMaterial.type === 'Hook Security' || currentMaterial.type === 'video/mp4'">
			<div class="flex-row gap-2 align-items-baseline" style="font-size: 14px; min-height: 30px;">
				<span class="flex-shrink-0 fw-500" style="flex-basis: 110px;">Video Subtitles:</span>
				<div class="flex-column gap-3 f-1-0">
					<div class="flex-row gap-1 flex-wrap justify-content-start align-items-center">
						<span *ngFor="let subtitleData of currentMaterial.subtitlesData; let last = last;">
							{{subtitleData.lang}}
							<ng-container *ngIf="subtitleData.isInProcess"><span class="text-muted" style="font-size: 12px;"> (in process)</span></ng-container>
							{{last ? '' : ','}}
						</span>
						<span class="text-muted" *ngIf="!currentMaterial.subtitlesData?.length">No subtitles added</span>
						<btn-c class="ms-2" variant="outlined"
							   endIcon="far fa-plus"
							   [isDisabled]="currentMaterial.video_status === 'in process'"
							   [tooltip]="currentMaterial.video_status === 'in process' ? 'Please wait for video generation to complete' : null"
							   *ngIf="!currentMaterial.showAddSubtitles"
							   (action)="currentMaterial.showAddSubtitles = true;">
							Add
						</btn-c>
					</div>

					<div class="flex-row gap-2 align-items-center f-1-0 animated fadeIn"
						 *ngIf="currentMaterial.showAddSubtitles">
						<app-dropdown-c style="width: 250px;"
										[items]="currentMaterial.subtitleLanguages"
										itemDisplayKey="display"
										[isMultipleSelection]="true">
						</app-dropdown-c>
						<btn-c [loading]="currentMaterial.generateSubtitlesInProcess"
							   (action)="generateMaterialSubtitles(currentMaterial)">
							Generate Subtitles
						</btn-c>
					</div>
				</div>

			</div>
		</div>

		<ng-template #currentMaterialField let-fieldName>
			<div class="flex-row gap-2 break-word" style="font-size: 14px; min-height: 30px;">
				<span class="flex-shrink-0 fw-500" style="flex-basis: 110px;">{{fieldName === 'link_url' ? 'URL' : _.startCase(fieldName)}}:</span>
				<span class="animated fadeIn" *ngIf="fieldName !== 'tags' && (!currentMaterial.edit || _.isUndefined(currentMaterial.edit[fieldName]))">
							{{_.truncate(currentMaterial[fieldName], {'length': 500}) || '-'}}
					<i class="far fa-edit cursor-pointer hvr-opacity opacity-75 ms-3" style="font-size: 13px;"
					   *ngIf="!currentMaterial.system"
					   tooltip="Edit {{fieldName === 'link_url' ? 'link URL' : fieldName}}"
					   (click)="startEditCurrentMaterial(fieldName);"></i>
						</span>
				<ng-container *ngIf="currentMaterial.edit && !_.isUndefined(currentMaterial.edit[fieldName])">
					<input class="f-1-0" style="margin-top: -7px;" type="text"
						   (keyup.enter)="confirmEditCurrentMaterial(fieldName);"
						   [(ngModel)]="currentMaterial.edit[fieldName]" />
					<btn-c style="min-width: 0; margin-top: -7px; align-self: baseline;"
						   endIcon="zmdi zmdi-check"
						   [isDisabled]="editMaterialInProcess || (!currentMaterial.edit[fieldName] && fieldName !== 'description')"
						   (action)="confirmEditCurrentMaterial(fieldName);">
					</btn-c>
					<btn-c style="min-width: 0; margin-top: -7px; align-self: baseline;"
						   endIcon="zmdi zmdi-close" color="danger"
						   variant="text"
						   (action)="currentMaterial.edit[fieldName] = undefined;">
					</btn-c>
				</ng-container>

				<!--tags-->
				<div class="flex-row gap-1 flex-wrap justify-content-start" *ngIf="fieldName === 'tags'">
							<span *ngFor="let tag of currentMaterial.tags; let last = last;">
								{{_.startCase(tag)}}{{last ? '' : ',&nbsp;'}}
							</span>
				</div>
			</div>
		</ng-template>
	</div>

	<div class="flxClmn-center f-1-0 overflow-auto" [ngClass]="{'bg-light' : currentMaterial.content}">
		<attachment-preview class="stretch-video-size"
			*ngIf="currentMaterial.content"
			[attachment]="currentMaterial"
			[isHeadless]="true"
			[videoSubtitles]="currentMaterial.video_subtitles">
		</attachment-preview>

		<iframe
			*ngIf="currentMaterial.link_url && currentMaterial.type !== 'AI' && currentMaterial.type !== 'Trustifi AI' && currentMaterial.type !== 'Hook Security'"
			[src]="previewLinkMaterial"
			referrerpolicy="strict-origin-when-cross-origin"
			width="100%"
			height="500"
			frameborder="0"
			allowfullscreen>
		</iframe>

		<div class="flex-column centralize overflow-hidden" *ngIf="currentMaterial.video_status === 'in process'">
			<video style="filter: brightness(1.08); height: min(43vh, 100%);"
				   autoplay muted loop playsinline>
				<source src="images/loader.webm" type="video/webm">
			</video>
			<span class="loading-dots fw-bold" style="margin-top: -36px; z-index: 50; font-size: 1rem;">Working on your video... This may take up to 10 minutes</span>
		</div>

		<div class="flex-column f-1-0 border border-light border-1 position-relative overflow-hidden" *ngIf="currentMaterial.pptUrl">
			<iframe
				class="f-1-0" style="z-index: 50; margin: -1px;"
				[src]="currentMaterial.pptUrl"
				frameborder="0"
				allowfullscreen>
			</iframe>
			<span class="absolute-centralize loading-dots" style="z-index: 20;">Loading presentation</span>
		</div>

		<threat-simulation-quiz-preview style="display: contents;"
										*ngIf="currentMaterial.type === 'quiz'"
										[materialObj]="currentMaterial">
		</threat-simulation-quiz-preview>

		<div class="flex-column f-1-0 gap-2 overflow-auto" *ngIf="(currentMaterial.type === 'AI' || currentMaterial.type === 'Trustifi AI' || currentMaterial.type === 'Hook Security') && currentMaterial.link_url">
			<span class="fst-italic align-self-end" *ngIf="currentMaterial.type === 'Hook Security'">Powered by Hook Security</span>
			<span class="fst-italic align-self-end" *ngIf="currentMaterial.type === 'Trustifi AI'">Powered by Trustifi AI</span>
			<hls-player class="f-1-0 overflow-auto by-height" [src]="currentMaterial.link_url" [videoSubtitles]="currentMaterial.video_subtitles"></hls-player>
		</div>
	</div>
</ng-template>

<popup-c class="no-content-padding bs-enabled" *ngIf="newMaterialPopup?.show"
		 head="Add Training Material" size="large"
		 subTitle="Upload materials to use in your training campaign"
		 (closeCb)="newMaterialPopup = null;"
		 (confirmCb)="confirmNewMaterialPopup();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: newMaterialPopup.addMaterialsInProcess}}">
	<div class="flex-column f-1-0" style="overflow: auto;">
		<div class="flex-column f-1-0 gap-5 p-4">
			<div class="flex-row gap-2" style="min-height: 150px;">
				<label class="radio-container m-0 mt-1 d-block flex-shrink-0" style="flex-basis: 180px;">
					Supported file types: MP4, PDF, Presentation files<br/><br/>
					<span style="font-size: 11px;">*File size limit: 100MB</span>
					<input type="radio"
						   [(ngModel)]="newMaterialPopup.type"
						   (ngModelChange)="newMaterialPopup.error = false;"
						   [value]="'file'">
					<span class="checkmark"></span>
				</label>
				<div class="d-flex f-1-0 centralize bg-light ellipsis"
					 ngfDrop
					 ngfSelect
					 [(file)]="newMaterialPopup.uploadFile"
					 [fileDropDisabled]="newMaterialPopup.type !== 'file'"
					 (fileChange)="newMaterialPopup.error = false;"
					 [(validDrag)]="validDrag"
					 [(invalidDrag)]="invalidDrag"
					 [ngClass]="{'drag-and-drop-hover': validDrag, 'dragOverClassObj': validDrag,
									 'validation-error': newMaterialPopup.error && newMaterialPopup.type === 'file' && !newMaterialPopup.uploadFile,
									 'border border-2 border-secondary-subtle': !newMaterialPopup.error || newMaterialPopup.type !== 'file' || newMaterialPopup.uploadFile,
									 'disabled-overlay': newMaterialPopup.type !== 'file', 'cursor-pointer hvr-opacity': newMaterialPopup.type === 'file'}"
					 accept='application/pdf,
					application/vnd.ms-powerpoint,
					application/vnd.openxmlformats-officedocument.presentationml.presentation,
					video/mp4'>
					<div class="flex-column p-3 text-center ellipsis" style="font-size: 14px;" *ngIf="newMaterialPopup.uploadFile">
						<span class="fw-500 ellipsis">{{newMaterialPopup.uploadFile.name}}</span>
					</div>
					<span class="fw-500 text-muted" style="font-size: 14px;" *ngIf="!newMaterialPopup.uploadFile">
						Click here to upload or drag & drop
					</span>
				</div>
			</div>

			<div class="flex-row gap-2">
				<label class="radio-container m-0 mt-2 d-block" style="flex-basis: 180px;">
					Link:
					<input type="radio"
						   [(ngModel)]="newMaterialPopup.type"
						   [value]="'link'">
					<span class="checkmark"></span>
				</label>
				<div class="flex-column f-1-0 gap-2" [ngClass]="{'disabled-overlay' : newMaterialPopup.type !== 'link'}">
					<div class="flex-row gap-2 align-items-center">
						<span class="flex-shrink-0" style="flex-basis: 130px;">Name:</span>
						<input type="text" class="f-1-0" [(ngModel)]="newMaterialPopup.link.name"
							   (ngModelChange)="newMaterialPopup.error = false;"
							   [ngClass]="{'validation-error' : newMaterialPopup.error && newMaterialPopup.type === 'link' && (!newMaterialPopup.link.name || newMaterialPopup.link.url)}"/>
					</div>
					<div class="flex-row gap-2 align-items-center">
						<span class="flex-shrink-0" style="flex-basis: 130px;">URL:</span>
						<input type="text" class="f-1-0" [(ngModel)]="newMaterialPopup.link.url"
							   (ngModelChange)="newMaterialPopup.error = false;"
							   [ngClass]="{'validation-error' : newMaterialPopup.error && newMaterialPopup.type === 'link' && newMaterialPopup.link.name && !newMaterialPopup.link.url}"/>
					</div>
					<div class="flex-row gap-2 align-items-center">
						<span class="flex-shrink-0" style="flex-basis: 130px;">Description <span style="font-weight: 300;">(optional)</span>:</span>
						<input type="text" class="f-1-0" [(ngModel)]="newMaterialPopup.link.description"
							   [readonly]="newMaterialPopup.type !== 'link'"/>
					</div>
				</div>

			</div>

			<hr/>
			<div class="flex-row gap-2 align-items-center">
				<span style="flex-basis: 180px; flex-shrink: 0;">Quiz:</span>
				<btn-c (action)="openQuizCreationWizard()">Create a Quiz</btn-c>
			</div>
		</div>
	</div>
</popup-c>

<threat-simulation-quiz-creation-wizard
	*ngIf="quizCreationPopup?.show"
	[initialData]="quizCreationPopup.initialData"
	[isEditMode]="quizCreationPopup.isEditMode"
	(doneCb)="onQuizCreated($event)"
	(cancelCb)="quizCreationPopup = null">
</threat-simulation-quiz-creation-wizard>

<!--exchange connector/rules popup-->
<popup-c class="no-content-padding bs-enabled" size="large"
		 *ngIf="aiMaterialPopup?.show"
		 head="Create a Training Material with AI"
		 subTitle="Generate AI-powered security awareness training videos tailored for your organization."
		 (closeCb)="aiMaterialPopup.show = false;">
	<div class="flex-column overflow-auto f-1-0 pt-2 gap-2" style="padding: 20px; font-size: 15px;">
		<!--steps progress-->
		<div class="steps-container" style="font-size: 0.8rem;">
			<div class="step-tab"
				 *ngFor="let step of aiMaterialPopupSteps | keyvalue: gs.returnZero"
				 [ngClass]="{'active' : aiMaterialPopup.currentStep === step.value}">
				{{step.value}}
			</div>
		</div>

		<!--Steps content:-->
		<!--STEP: General instructions-->
		<div class="flex-column overflow-auto animated fadeIn f-1-0 gap-3 p-2 pt-3"
			 style="line-height: 2; font-size: 16x;"
			 *ngIf="aiMaterialPopup.currentStep === aiMaterialPopupSteps.generalInformation">
			<span>
				This wizard will help you create a personalized security-awareness training video.
			</span>
			<br/>
			<div class="flex-row gap-2 align-items-baseline">
				<span class="fw-bold">What's next?</span>
			</div>

			<div class="bg-light p-2">
				<ul style="list-style-type: number;">
					<li>
						<span>You will configure the video's outline, target audience, and length.</span>
					</li>
					<li>
						<span>The video will be generated automatically. Once it’s ready, you will receive an email notification.</span>
					</li>
					<li>
						<span>Your video will appear in the Training Materials list. From there, you can preview it and later use it in a training campaign.</span>
					</li>
				</ul>
			</div>
		</div>

		<!--STEP: Material Details-->
		<div class="flex-column f-1-0 animated fadeIn gap-3 p-2 pt-3" style="z-index: 50;"
			 *ngIf="aiMaterialPopup.currentStep === aiMaterialPopupSteps.materialDetails">
			<div class="list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2">
						<b>Title</b>
						<span style="font-size: 0.9em;">The title of the material will be displayed on materials list</span>
					</div>
					<div class="content-container flex-column gap-3">
						<input class="m-0 w-100" type="text"
							   [(ngModel)]="aiMaterialPopup.data.title"
							   [ngClass]="{'validation-error' : aiMaterialPopup.error && !aiMaterialPopup.data.title}"
							   (keyup)="aiMaterialPopup.error = ''"
							   placeholder="Enter title">
					</div>
				</div>
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2">
						<b>Video content</b>
						<span style="font-size: 0.9em;">Describe the overall topic of the video, they key points of focus, and the what you want your audience to learn from this video.</span>
					</div>
					<div class="content-container flex-column gap-3">
						<textarea class="m-0 color-equalized w-100" style="height: 135px;"
								  placeholder="Example: 'Create a video about the risks of opening unknown email attachments, including common threats hidden in attachments, real-world scenarios, and best practices to avoid them.'"
								  [(ngModel)]="aiMaterialPopup.data.description"></textarea>
						<div class="flex-row justify-content-between align-items-center">
							<span class="fw-500">Media <span class="text-muted fw-normal ms-2" style="font-size: 11px;">(500KB max. 2 files max. PNG/JPEG)</span></span>
							<div [(file)]="aiMaterialPopup.data.file"
								 (fileChange)="uploadAIVideoMediaFile()"
								 ngfSelect
								 accept=".png, .jpeg">
								<btn-c class="auto-height" style="min-width: 0;"
									   [endIcon]="'far fa-plus'"
									   variant="outlined"
									   [btnTooltip]="aiMaterialPopup.data.files.length >= 2 ? 'Max 2 media files' : null"
									   (click)="aiMaterialPopup.data.files.length >= 2 ? $event.stopPropagation() : null">
								</btn-c>
							</div>

						</div>

						<ng-container *ngIf="aiMaterialPopup.data.files.length">
							<div class="flex-row gap-3 align-items-center" *ngFor="let file of aiMaterialPopup.data.files">
								<div class="flxClmn-center hvr-opacity p-3" style="position: relative; cursor: pointer; align-items: center; border: solid 1px #e3e4e4; background: #fafafa; width: 100px; height: 100px;"
									 [tooltip]="file.fileData.name">
									<img [src]="'data:image/png;base64,' + file.previewBase64"
										 style="width: auto; height: auto; max-width: 100%; max-height: 100%;"/>
									<i (click)="$event.stopPropagation(); removeAIVideoMediaFile(file);"
									   style="position: absolute; top: 0; padding: 5px; right: 0;" class="far fa-times"></i>
								</div>
								<textarea class="m-0 align-self-stretch h-auto color-equalized f-1-0"
										  placeholder="Visualy describe this image or video. What does it show? What is its purpose?"
										  style="resize: none;"
										  [(ngModel)]="file.description"></textarea>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2">
						<b>Audience</b>
						<span style="font-size: 0.9em;">Selecting the audience will affect the video's content: jargon, methodics and overall focus.</span>
					</div>
					<div class="content-container flex-column gap-3">
						<app-dropdown-c class="w100 limit-height" [text]="aiMaterialPopup.data.audience || 'Select'">
							<li *ngFor="let audience of aiMaterialAudienceOptions"
								(click)="aiMaterialPopup.data.audience = audience">
								{{audience}}
							</li>
						</app-dropdown-c>
					</div>
				</div>
				<!--<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2">
						<b>Speaker gender</b>
						<span style="font-size: 0.9em;">Determine the gender of the avatar speaking in the video.</span>
					</div>
					<div class="content-container flex-column gap-3">
						<app-dropdown-c class="w100" [text]="aiMaterialPopup.data.botGender">
							<li *ngFor="let gender of ['Male', 'Female']"
								(click)="aiMaterialPopup.data.botGender = gender">
								{{gender}}
							</li>
						</app-dropdown-c>
					</div>
				</div>-->
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2">
						<b>Video length</b>
						<span style="font-size: 0.9em;">Select the desired length of the video in minutes. The output video will roughly be at this length.</span>
					</div>
					<div class="content-container flex-column gap-3">
						<app-dropdown-c class="w100 show-above" [text]="aiMaterialPopup.data.videoLength.toString() + ' minute' + (aiMaterialPopup.data.videoLength >= 2 ? 's' : '')">
							<li *ngFor="let time of [1,1.5,2,2.5]"
								(click)="aiMaterialPopup.data.videoLength = time">
								{{time}} minute{{time >= 2 ? 's' : ''}}
							</li>
						</app-dropdown-c>
					</div>
				</div>
			</div>
		</div>

		<!--STEP: Material Details-->
		<div class="flex-column f-1-0 animated fadeIn gap-3 p-2 pt-3" *ngIf="aiMaterialPopup.currentStep === aiMaterialPopupSteps.generate && !aiMaterialPopup.addMaterialsInProcess">
			<div class="flex-column f-1-0 gap-4 p-4">
				<h6>Video details:</h6>
				<div class="flex-column f-1-0 gap-4 py-2 px-4">
					<div class="flex-row gap-2 align-items-center">
						<span class="fw-500" style="flex-basis: 120px; flex-shrink: 0;">Title:</span>
						<span>{{aiMaterialPopup.data.title}}</span>
					</div>
					<div class="flex-row gap-2 align-items-start">
						<span class="fw-500" style="flex-basis: 120px; flex-shrink: 0;">Video content:</span>
						<span>{{aiMaterialPopup.data.description}}</span>
					</div>
					<div class="flex-row gap-2 align-items-start">
						<span class="fw-500" style="flex-basis: 120px; flex-shrink: 0;">Audience:</span>
						<span>{{aiMaterialPopup.data.audience}}</span>
					</div>
					<!--<div class="flex-row gap-2 align-items-start">
						<span class="fw-500" style="flex-basis: 120px; flex-shrink: 0;">Speaker gender:</span>
						<span>{{aiMaterialPopup.data.botGender}}</span>
					</div>-->
					<div class="flex-row gap-2 align-items-start">
						<span class="fw-500" style="flex-basis: 120px; flex-shrink: 0;">Video length:</span>
						<span>{{aiMaterialPopup.data.videoLength.toString() + ' minute' + (aiMaterialPopup.data.videoLength >= 2 ? 's' : '')}}</span>
					</div>
				</div>
			</div>
			<div class="flex-column gap-2 px-2">
				<hr class="mt-0"/>
				<span>After clicking on <b>Generate</b>, the AI will start generating your video.</span>
				<ul style="list-style-type: circle;">
					<li>
						<span>The video will be ready after roughly 10 minutes.</span>
					</li>
					<li>
						<span>Once the video is ready you will receive an email notification, and you can then view the video from the "Training Materials" page.</span>
					</li>
				</ul>
			</div>
		</div>

		<!--STEP: Material Details-->
		<div class="flex-column f-1-0 animated fadeIn gap-1 p-2 pt-3" *ngIf="aiMaterialPopup.addMaterialsInProcess">
			<div class="flex-column centralize f-1-0 gap-2 p-2">
				<img src="images/ai-spinner.gif" style="filter: contrast(1.2);"/>
				<span class="loading-dots">Generating</span>
			</div>
		</div>

		<!--error message and buttons-->
		<div class="flex-row justify-content-between align-items-end mb-3 px-4 w-100">
			<!--<span class="f-1-0 pe-3 text-danger" style="min-height: 40px;">
				{{aiMaterialPopup.error || ' '}}
			</span>-->
			<div class="f-1-0">
				<btn-c class="popup-action-btn" variant="text" color="warning"
					   *ngIf="aiMaterialPopup.currentStep === aiMaterialPopupSteps.materialDetails"
					   style="min-width: 0;"
					   (action)="openNewMaterialAiWizard(); aiMaterialPopup.currentStep = aiMaterialPopupSteps.materialDetails;">
					Reset
				</btn-c>
			</div>


			<div class="flex-row gap-3" style="font-size: 13px;">
				<btn-c class="popup-action-btn"
					   *ngIf="aiMaterialPopup.currentStep === aiMaterialPopupSteps.generalInformation"
					   variant="outlined"
					   (action)="aiMaterialPopup.show = false; aiMaterialPopup.currentStep = aiMaterialPopupSteps.generalInformation;">
					Cancel
				</btn-c>
				<btn-c class="popup-action-btn"
					   [isDisabled]="aiMaterialPopup.addMaterialsInProcess"
					   *ngIf="aiMaterialPopup.currentStep !== aiMaterialPopupSteps.generalInformation"
					   variant="outlined"
					   (action)="aiVideoWizardBackStep();">
					Back
				</btn-c>
				<btn-c class="popup-action-btn"
					   *ngIf="aiMaterialPopup.currentStep !== aiMaterialPopupSteps.generate"
					   (action)="aiVideoWizardNextStep();">
					Next
				</btn-c>
				<btn-c class="popup-action-btn"
					   [loading]="aiMaterialPopup.addMaterialsInProcess"
					   *ngIf="aiMaterialPopup.currentStep === aiMaterialPopupSteps.generate"
					   (action)="generateAiVideo();">
					Generate
				</btn-c>
			</div>
		</div>
	</div>
</popup-c>

